import { render } from "./QuestionScreen.vue?vue&type=template&id=77104fbc"
import script from "./QuestionScreen.vue?vue&type=script&lang=js"
export * from "./QuestionScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/scania_guess_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__